import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "lk-portal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view),
    (!_ctx.isProd)
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMock && _ctx.toggleMock(...args))),
          class: _normalizeClass(['mock-toggle-icon', `${_ctx.mockState.mockType}`])
        }, null, 2))
      : _createCommentVNode("", true)
  ]))
}